@if (
  {
    currentStatus: currentStatus$ | async,
    positiveStatuses: positiveStatuses$ | async,
  };
  as data
) {
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-item [style.background-color]="data.currentStatus?.color">
          @if (data.currentStatus.isPositive()) {
            <div class="statusWrapper">
              @for (status of data.positiveStatuses; track status; let last = $last) {
                <div
                  [style.background-color]="status.color"
                  class="status-colored"
                  [ngClass]="status.id === data.currentStatus.id ? 'active' : 'inactive'"
                >
                  {{ status.humanReadableName }}
                </div>
                @if (!last) {
                  <div class="connector"></div>
                }
              }
            </div>
          }
          @if (data.currentStatus.isNegative()) {
            <div [style.background-color]="data.currentStatus.color" class="status-colored active">
              {{ data.currentStatus.humanReadableName }}
            </div>
          }
          @if (editable) {
            <ion-buttons slot="end">
              @if (data.currentStatus.name === AssistanceStatusName.HAS_ASSISTANT) {
                <ion-button
                  fill="outline"
                  data-cy="btnSendToAssistant"
                  (click)="advanceStatus()"
                  [disabled]="!isStatusChangeAllowed()"
                >
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                  Zaslat asistentovi
                </ion-button>
              }
              @if (data.currentStatus.name === AssistanceStatusName.SENT_TO_ASSISTANT) {
                <ion-button
                  fill="outline"
                  data-cy="btnConfirm"
                  (click)="advanceStatus()"
                  [disabled]="!isStatusChangeAllowed()"
                >
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                  Potvrdit
                </ion-button>
              }
              @if (canShowStatusButtonCancel(data.currentStatus)) {
                <ion-button
                  color="danger"
                  fill="outline"
                  data-cy="btnCancel"
                  (click)="requestCancel()"
                  [disabled]="!isStatusChangeAllowed()"
                >
                  <ion-icon name="close-outline"></ion-icon>
                  Zrušit
                </ion-button>
              }
            </ion-buttons>
          }
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
}
